export default "__VITE_ASSET__CAB6ajE2__"